import React, { useEffect, useState } from 'react';
import {Elements} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';
import StripeCheckoutForm from './StripeCheckoutForm';  
import { useSelector } from 'react-redux';

function convertToStripeAmount (amount) {
  return parseInt(amount.toFixed(2)) * 100
}

const StripePaymentForm = ({reservation, ...props}) => {
  const amount = reservation ? convertToStripeAmount(reservation.remainingDepositAmount) : 0;
  const [stripeReady, setStripeReady] = useState(false);

  const options = {
    locale: reservation.language,
    appearance: {
      // https://docs.stripe.com/elements/appearance-api#theme , https://docs.stripe.com/payments/payment-element
      theme: "night",
      labels: "floating",
      fontFamily: "Barlow, sans-serif",
      rules: {
        ".Input": {
          border: "1px solid #3d3d3d",
          color: "#fff",
          borderRadius: "10px",
          backgroundColor: "#121212",
        },
        ".Input:focus": {
          border: "1px solid #3d3d3d",
          boxShadow: "none",
        },
        ".Label--resting": {
          color: "#7e7e7e",
          fontWeight: 500,
        },
        ".Label--floating": {
          color: "#7e7e7e",
          fontWeight: "500",
          textShadow: "3px 0px 0px #000000, -3px 0 0px #000000",
        },
        ".AccordionItem": {
          border: "none",
          padding: "0px",
        },
        ".Block": {
          backgroundColor: "#121212",
        },
        ".Tab": {
          border: "1px solid #3d3d3d",
          color: "#898989",
        },
        ".Tab:focus": {
          border: "1px solid #1d9bf0",
          boxShadow: "none" ,
          backgroundColor: "#1d9bf0",
        },
        ".Tab--selected:active": {
          border: "1px solid #1d9bf0",
          boxShadow: "none" ,
          backgroundColor: "#1d9bf0",
        },
        ".Tab--selected": {
          border: "1px solid #1d9bf0",
          boxShadow: "none" ,
          backgroundColor: "#1d9bf0",
        },
        ".TabLabel": { color: "#7e7e7e" },
        ".TabLabel--selected": { color: "#ffffff" }
      },
      variables: {
        colorPrimary: '#1d9bf0',
        colorText: "#fff",
        colorBackground: "#000",
        colorDanger: "#f80005",
        fontSizeBase: "1rem",
        fontSizeSm: "0.875rem",
        fontWeightNormal: "400",
        colorIcon: "#fff",
        tabIconColor: "#7e7e7e",
        tabIconSelectedColor: '#ffffff'
      },
    },
  };

  if(reservation.gateway.paymentIntentClientSecret) {
    options.clientSecret = reservation.gateway.paymentIntentClientSecret;
  }
  else {
    options.mode = 'payment';
    options.amount = amount;
    options.currency = reservation.currency.toLowerCase();
    options.paymentMethodCreation = 'manual';
  }

  if(reservation.gateway.accountId && !reservation.gateway.isDirectCharge) {
    options.on_behalf_of = reservation.gateway.accountId;
  }

  useEffect(() => {
    if(!reservation) return;
    if(window.stripePromise === undefined) {
      let options = {
        locale: reservation.language
      };
      if(reservation.gateway.accountId && reservation.gateway.isDirectCharge) {
        options.stripeAccount = reservation.gateway.accountId;
      }
      window.stripePromise = loadStripe(reservation.gateway.publicKey, options);
      setStripeReady(true);
    }
  }, [reservation])

  if(!stripeReady && !window.stripePromise) return null;

  return (
    <Elements stripe={window.stripePromise} options={options}>
      <StripeCheckoutForm reservation={reservation} {...props}/>
    </Elements>
  );
};

export default StripePaymentForm;
